import React from "react";
import { Modal } from "antd";
import PropTypes from "prop-types";
import ScheduleInterviewForm from "../Form/ScheduleInterviewForm";

const ScheduleInterviewModal = ({ isVisible, onCancel, onSave }) => {
  return (
    <Modal open={isVisible} onCancel={onCancel} footer={null} width={700} centered className="interview-modal" title={null} destroyOnClose>
      <div className="text-center mb-8">
        <h1 className="text-3xl font-bold uppercase tracking-tight">Schedule an Interview</h1>
      </div>

      <ScheduleInterviewForm onCancel={onCancel} onSave={onSave} onClose={onCancel} />
    </Modal>
  );
};

ScheduleInterviewModal.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
};

export default ScheduleInterviewModal;
